export default {"src":"/_next/static/media/build-projects.cdf96e24.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};